export const LOAD_CRUCESINTERNACIONALES_SUCCESS = 'LOAD_CRUCESINTERNACIONALES_SUCCESS';

export interface ICruceInternacional {
    id: number
    cruce: string
    sucursalID: number
}

interface ILoadCrucesInternacionales {
    type: typeof LOAD_CRUCESINTERNACIONALES_SUCCESS
    crucesInternacionales: ICruceInternacional[]
}

export type CruceInternacionalActionTypes = ILoadCrucesInternacionales
